import { C06PromoCarouselCTAProps } from './C06PromoCarouselCTA.types';
import { getComponentsFromPlaceholder } from 'src/shared/placeholder-utils';
import { getDroplink } from 'src/shared/param-utils';
import { GetPromoCalloutModel } from '../C07PromoCTA/C07PromoCTA.service';
import { PROMO_CAROUSEL_CTAS, PROMO_CTA_COMPONENT_NAME } from 'src/shared/static';
import { PromoCallout, PromoCarouselProps } from '@ahc-digital/component-library';

export function GetPromoCarouselModel(props?: C06PromoCarouselCTAProps): PromoCarouselProps {
  const { params, rendering } = props || {};

  return {
    backgroundColor: getDroplink(params?.BackgroundColor, 'wellnessBlue'),
    imageSide: getDroplink(params?.ImageSide, 'left'),
    secondCTAStyle: getDroplink(params?.SecondCTAStyle, 'solid'),
    slides: getComponentsFromPlaceholder({
      placeholder: rendering?.placeholders?.[PROMO_CAROUSEL_CTAS],
      componentName: PROMO_CTA_COMPONENT_NAME,
      Component: PromoCallout,
      modelFactory: GetPromoCalloutModel,
    }),
    slideTimingSeconds: parseInt(params?.SlideTiming ?? '6'),
    textAlignment: getDroplink(params?.TextAlignment, 'left'),
  };
}
